eficienciaFiscalModule = angular.module('eficienciaFiscalModule')

eficienciaFiscalModule.animation('.slide-animation', ->
  addClass: (element, className, done) ->
    delay = $(element).attr('delay') || 400
    $(element).slideUp(delay, done) if className == 'ng-hide'
    (isCancelled) ->
      $(element).stop() if isCancelled

  removeClass: (element, className, done) ->
    delay = $(element).attr('delay') || 400
    if className == 'ng-hide'
      $(element).css({display: 'none'})
      $(element).slideDown(delay, done)
    (isCancelled) ->
      $(element).stop() if isCancelled
)

eficienciaFiscalModule.animation('.fade-animation', ->
  addClass: (element, className, done) ->
    $(element).fadeOut(200, done) if className == 'ng-hide'
    (isCancelled) ->
      $(element).stop() if isCancelled

  removeClass: (element, className, done) ->
    if className == 'ng-hide'
      $(element).css({display: 'none'})
      $(element).fadeIn(200, done)
    (isCancelled) ->
      $(element).stop() if isCancelled
)

eficienciaFiscalModule.animation('.repeat-animation', ->
  enter: (element, done) ->
    $(element)
      .css({display: 'none', opacity: '0'})
      .slideDown(400)
      .animate({opacity: '1'}, {duration: 400, complete: done, queue: false})

    (isCancelled) ->
      $(element).stop() if isCancelled

  leave: (element, done) ->
    element.css('display', null)
    $(element).slideUp(400, done)
    $(element).fadeOut(400, done)

    (isCancelled) ->
      $(element).stop() if isCancelled

  move: (element, done) ->
    element.css('display', 'none')
    $(element).slideDown(400, done)
    $(element).fadeIn(400, done)

    (isCancelled) ->
      $(element).stop() if isCancelled
)
